import { Utils } from "../Utils/Utils.js";
export class EventsCachedMesh {
    static _registeredMesh = {};
    static _pendingMeshes = [];
    static update() {
        if (this._pendingMeshes.length > 0) {
            for (let pendingMesh of this._pendingMeshes) {
                this.registerPendingMesh(pendingMesh);
            }
            this._pendingMeshes = [];
        }
    }
    static getRegisteredMesh(eventName, sceneId) {
        if (this._registeredMesh[sceneId]) {
            return this._registeredMesh[sceneId][eventName];
        }
        return undefined;
    }
    static registerPendingMesh(pendingMesh) {
        let sceneId = Utils.getSceneFromMesh(pendingMesh.mesh).id; //todo cache
        if (!this._registeredMesh[sceneId]) {
            this._registeredMesh[sceneId] = {};
        }
        if (this._registeredMesh[sceneId][pendingMesh.event]) {
            this._registeredMesh[sceneId][pendingMesh.event].push(pendingMesh.mesh);
        }
        else {
            this._registeredMesh[sceneId][pendingMesh.event] = [pendingMesh.mesh];
        }
    }
    static register(mesh, eventName) {
        if (eventName == "onFrameGeneration" || eventName == "onWindowResize") {
            this._pendingMeshes.push({
                event: eventName,
                mesh
            });
        }
    }
    static unregister(mesh, eventName) {
        if (eventName == "onFrameGeneration" || eventName == "onWindowResize") {
            let sceneId = Utils.getSceneFromMesh(mesh).id; //todo cache
            let index = this._registeredMesh[sceneId][eventName].indexOf(mesh);
            this._registeredMesh[sceneId][eventName].splice(index, 1);
        }
    }
    static unregisterMeshAndChildren(mesh) {
        let sceneId = Utils.getSceneFromMesh(mesh).id; //todo cache
        let registeredMeshInScene = this._registeredMesh[sceneId];
        if (registeredMeshInScene) {
            for (let key in registeredMeshInScene) {
                let event = registeredMeshInScene[key];
                let index = event.indexOf(mesh);
                if (index != -1) {
                    event.splice(index, 1);
                }
            }
        }
        if (mesh.children) {
            for (let child of mesh.children) {
                this.unregisterMeshAndChildren(child);
            }
        }
    }
}
//# sourceMappingURL=EventsCachedMesh.js.map